import type { ButtonHTMLAttributes } from 'react';
import styles from './GenerateButton.module.css';
import '../../../styles/generation-common.css';

export interface GenerateButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  label: string;
  creditCost?: number | string;
  isLoading?: boolean;
  loadingLabel?: string;
  showLoadingDots?: boolean;
}

export function GenerateButton({
  label,
  creditCost,
  isLoading = false,
  loadingLabel,
  showLoadingDots = false,
  type = 'button',
  className,
  ...rest
}: GenerateButtonProps) {
  const combinedClassName = [
    styles.button,
    isLoading ? 'ai-loading-active' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={combinedClassName} {...rest}>
      {isLoading ? (
        <span className="btn-label">
          {loadingLabel ?? label}
          {showLoadingDots && (
            <span className="ai-loading-dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          )}
        </span>
      ) : (
        <>
          <span className="btn-label">{label}</span>
          {creditCost !== undefined && (
            // generate-button-badge は buttons.css の btn-ai-director 系がバッジ有無で右の余白を変えるためのフック
            <span className={`${styles.badge} generate-button-badge`}>{creditCost}</span>
          )}
        </>
      )}
    </button>
  );
}
